import { IntlShape } from 'react-intl';

import { DestinationsMenuTopDestination } from '../../../resources/destinationsMenu/domain/types/destinationsMenu';
import { RouteName, RouteParams } from '../../../shared/utilities/routing/routing';
import { SearchSubmissionTarget } from '../SearchOverlay.types';

type GeneratePath = (name: RouteName, params?: RouteParams) => string;

export type FallbackRow =
    | { key: string; kind: 'globe'; target: SearchSubmissionTarget }
    | { key: string; kind: 'map'; target: SearchSubmissionTarget }
    | {
          key: string;
          kind: 'top-destination';
          target: SearchSubmissionTarget;
          destination: DestinationsMenuTopDestination;
      };

export function buildEmptyFallbackRows(
    topDestinations: DestinationsMenuTopDestination[],
    formatMessage: IntlShape['formatMessage'],
    generatePath: GeneratePath,
): FallbackRow[] {
    const rows: FallbackRow[] = topDestinations.map((destination) => ({
        key: `top-${destination.id}`,
        kind: 'top-destination',
        target: {
            amplitudeDestinationType: 'coup de coeur',
            label: destination.name,
            href: generatePath('destination', { destinationSlug: destination.slug }),
        },
        destination,
    }));

    rows.push({
        key: 'world',
        kind: 'globe',
        target: {
            amplitudeDestinationType: 'autre desti',
            label: formatMessage({ id: 'page.home.destinations.worldPage' }),
            href: generatePath('destination_list'),
        },
    });

    return rows;
}

export function buildNoResultsFallbackRows(
    topDestinations: DestinationsMenuTopDestination[] | undefined,
    formatMessage: IntlShape['formatMessage'],
    generatePath: GeneratePath,
): FallbackRow[] {
    const rows: FallbackRow[] = [
        {
            key: 'where-to-go',
            kind: 'map',
            target: {
                amplitudeDestinationType: 'où partir ?',
                label: formatMessage({
                    id: 'global.search.overlay.noResults.whereToGo',
                }),
                href: generatePath('where_to_go'),
            },
        },
        {
            key: 'world',
            kind: 'globe',
            target: {
                amplitudeDestinationType: 'autre desti',
                label: formatMessage({ id: 'page.home.destinations.worldPage' }),
                href: generatePath('destination_list'),
            },
        },
    ];

    topDestinations?.forEach((destination) => {
        rows.push({
            key: `top-${destination.id}`,
            kind: 'top-destination',
            target: {
                amplitudeDestinationType: 'coup de coeur',
                label: destination.name,
                href: generatePath('destination', { destinationSlug: destination.slug }),
            },
            destination,
        });
    });

    return rows;
}
